import useApiQuery from 'shared/hooks/use-api-query';
import {ProductProps} from '../types';
import productsKeys from '../util/products-keys';

const useProductsByIds = (productsIds: string[]) => {
  return useApiQuery<ProductProps[]>({
    url: `/products/ids?productsIds=${JSON.stringify(productsIds)}`,
    queryKey: productsKeys.ids(productsIds),
    enabled: productsIds.length > 0,
  });
};

export default useProductsByIds;
